module.exports = "/images/tvs_moto_shadow.png?fe920dc1b3c483f0aafc94acfaea3891";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tvs_moto_shadow.png
// module id = 4aM7
// module chunks = 0